import { useLiveCelebration } from 'src/hooks/live-activity/use-live-celebration';

import { LiveCelebration } from './live-celebration';

// ----------------------------------------------------------------------

/**
 * Montado una sola vez en el layout del backoffice (no dentro de la vista del Tracker): así el
 * confeti/cartel de "nuevo pedido" y su sonido se ven/oyen en cualquier pantalla (Usuarios,
 * Pedidos...), no solo estando en Tracker en vivo. No pinta nada mientras no hay nada que
 * celebrar, y el propio hook ya se calla del todo si no eres Administrador.
 */
export function GlobalLiveCelebration() {
  const { celebration, soundEnabled, soundByKind } = useLiveCelebration();

  return (
    <LiveCelebration celebration={celebration} soundEnabled={soundEnabled} soundByKind={soundByKind} />
  );
}
